import { loginRequestSX } from '@/components/content/Header/styles/account/panel';
import { useSessionDialog } from '@/data/Content/SessionDialog';
import { useLocalization } from '@/data/Localization';
import { useUser } from '@/data/User';
import { logEvent } from '@/data/utils/logEventsUtils';
import { useMobileApp } from '@/utils/useMobileApp';
import { Button, Stack, Theme, Typography } from '@mui/material';

type Props = {
	theme: Theme;
	onClose?: () => void;
};

export const LoginRequestSection: React.FC<Props> = ({ onClose }) => {
	const { user } = useUser();
	const { openSessionDialog } = useSessionDialog();
	const labels = useLocalization('HeaderAccountPanel');
	const { isMobileApp } = useMobileApp();

	const openLoginModal = () => {
		if (!user?.isLoggedIn) {
			openSessionDialog('signIn');
			if (onClose) onClose();
		}
	};

	const openRegisterModal = (e: React.MouseEvent) => {
		if (isMobileApp) {
			e.preventDefault();
			logEvent('onRegisterClick');
			return;
		}

		if (!user?.isLoggedIn) {
			openSessionDialog('register');
			if (onClose) onClose();
		}
	};

	return (
		<Stack sx={loginRequestSX.container}>
			<Typography variant="body2" sx={loginRequestSX.message}>
				{labels.LogInRequest.Msg.t()}
			</Typography>
			<Stack sx={loginRequestSX.buttonContainer}>
				<Button
					variant="contained"
					sx={loginRequestSX.signInButton}
					onClick={openLoginModal}
					className="account-panel__guest-login"
				>
					{labels.LogInRequest.SignIn.t()}
				</Button>
				<Button
					variant="outlined"
					sx={loginRequestSX.registerButton}
					onClick={openRegisterModal}
					className="account-panel__guest-register"
				>
					{labels.LogInRequest.CreateAccount.t()}
				</Button>
			</Stack>
		</Stack>
	);
};
